import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import CategoryExpenseBox from '../Category/CategoryExpenseBox';
import { useLanguage } from '../../context/LanguageContext';

// Skeleton Loader for Expense Cards
const ExpenseSkeleton = () => (
    <div className="col-6">
        <div className="expense-box skeleton-expense">
            <div
                className="skeleton-loading"
                style={{ width: '100%', height: '80px', borderRadius: '12px' }}
            ></div>
        </div>
    </div>
);

function TopExpenses({ expenseData }) {
    const { t } = useLanguage();

    // Check loading state - if expenseData is null/undefined, show loading
    const isLoading = !Array.isArray(expenseData);
    const isEmpty = Array.isArray(expenseData) && expenseData.length === 0;
    const hasExpenses = Array.isArray(expenseData) && expenseData.length > 0;

    const renderExpenseCards = useCallback(() => {
        if (isLoading) {
            // Show skeleton loaders while loading
            return Array.from({ length: 4 }).map((_, idx) => (
                <ExpenseSkeleton key={`skeleton-${idx}`} />
            ));
        }

        // Only reached with a non-empty array (empty state is rendered separately)
        return expenseData.map((expense) => (
            <div key={expense.category_id} className="col-6">
                <CategoryExpenseBox expense={expense} />
            </div>
        ));
    }, [expenseData, isLoading]);

    return (
        <section>
            <div className="custom-container">
                <div className="title">
                    <h2>{t('topExpenses')}</h2>
                    {hasExpenses && (
                        <Link
                            to="/category-expense"
                            className="see-all-link"
                            aria-label={t('seeAll')}
                        >
                            {t('seeAll')}
                        </Link>
                    )}
                </div>

                {hasExpenses && (
                    <div className="title">
                        <h4 className="margin-bottom-10">{t('thisMonth')}</h4>
                    </div>
                )}

                <div
                    className="row gy-3"
                    role={hasExpenses ? 'list' : 'status'}
                    aria-label={t('topExpenses')}
                >
                    {!isEmpty ? (
                        renderExpenseCards()
                    ) : (
                        <div className="col-12">
                            <div className="empty_state" role="img" aria-label={t('noExpenses')}>
                                <img
                                    className="img-fluid-custom transaction-icon"
                                    src={'assets/images/svg/Empty-rafiki.svg'}
                                    alt=""
                                />
                                <h3>{t('noExpenses')}</h3>
                                <p>{t('noExpenseThisMonth')}</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}

export default TopExpenses;
